import { render, staticRenderFns } from "./MainBody.vue?vue&type=template&id=a24f6e04&scoped=true&"
import script from "./MainBody.vue?vue&type=script&lang=js&"
export * from "./MainBody.vue?vue&type=script&lang=js&"
import style0 from "./MainBody.vue?vue&type=style&index=0&id=a24f6e04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24f6e04",
  null
  
)

export default component.exports